<template>
  <div id="drop-zone">
    
  </div>
</template>

<script>
export default {
  name: 'DropZone',
}
</script>
